const UNAUTHORIZED_API =
  "Your session has expired. Please sign in to continue.";

const FORBIDDEN_API =
  "Your account is not authorized to access the requested application. Please contact your DoubleVerify representative for assistance.";

const UNAUTHORIZED_APPLICATION =
  "Your account is not authorized to access the requested application. Please contact your DoubleVerify representative for assistance.";

const CONCURRENT_SESSIONS =
  "You have reached the maximum number of concurrent sessions. Log in here to terminate an open session on another device and continue working.";

const EXPIRED_SUBSCRIPTION = `Our records indicate that your subscription has expired. 
Please contact your DoubleVerify Sales representative for assistance.`;

const AUTH_ERROR = "There was an error accessing your account";

const ACCOUNT_UPDATED = "Your account has been updated.";

export {
  UNAUTHORIZED_API,
  FORBIDDEN_API,
  UNAUTHORIZED_APPLICATION,
  CONCURRENT_SESSIONS,
  EXPIRED_SUBSCRIPTION,
  AUTH_ERROR,
  ACCOUNT_UPDATED
};
